<template>
    <ProtocolList/>
</template>

<script>

    import ProtocolList from "@/viewer/protocol/ProtocolList.vue";

    export default {
        name: "BudgetList",
        components: {ProtocolList},
    }
</script>

<style scoped>

</style>
